<section class="app-dialog bsc-captura-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <span class="bsc-captura-dialog__icono" aria-hidden="true">
        <span class="material-icons">edit_calendar</span>
      </span>
      <div>
        <p class="app-dialog__eyebrow">Capturar {{ mesTexto }} · Q{{ q }}</p>
        <h2 [id]="idTitulo">{{ objetivo }}</h2>
        <p>{{ encabezado }}</p>
      </div>
    </div>
    <button type="button" class="app-dialog__close bsc-captura-dialog__cerrar" aria-label="Cerrar" [disabled]="enviando"
            (click)="cancelar()">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </header>

  <div mat-dialog-content class="app-dialog__content bsc-captura-dialog__contenido">
    <div class="bsc-captura-dialog__aviso is-error" *ngIf="bloqueado" role="alert">
      <strong>Q{{ q }} ya se {{ datos.estatusTrimestre === "AUTORIZADO" ? "autorizó" : "envió a revisión" }}: {{ mesTexto }} ya no se captura.</strong>
      <p>Si hay que corregir, Dirección lo regresa (o lo reabre) y vuelve a quedar en captura.</p>
    </div>

    <!-- ============================ El mes ============================ -->
    <fieldset class="bsc-captura-dialog__grupo">
      <legend>
        <span>{{ mesNombre }}</span>
        <span class="table-page__status-badge" *ngIf="estadoMes" [ngClass]="estadoMes.clase">
          <span class="material-icons" aria-hidden="true">{{ estadoMes.icono }}</span>
          {{ estadoMes.texto }}
        </span>
      </legend>
      <p class="bsc-captura-dialog__nota" *ngIf="capturo">{{ capturo }}</p>
      <p class="bsc-captura-dialog__nota is-aviso" *ngIf="!aplica">{{ textoNa }}</p>

      <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
        <mat-label>Actividad planeada</mat-label>
        <textarea matInput [id]="idActividad" rows="3" [(ngModel)]="actividad"
                  (ngModelChange)="cambio()" [disabled]="enviando || bloqueado || terminado || recargar"></textarea>
        <mat-hint>Qué se hizo o se planeó en {{ mesTexto }}.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
        <mat-label>Evidencia / resultado</mat-label>
        <textarea matInput aria-label="Evidencia / resultado" id="bsc-captura-evidencia" rows="3" [(ngModel)]="evidencia" (ngModelChange)="cambio()"
                  [disabled]="enviando || bloqueado || terminado || recargar"></textarea>
        <mat-hint>Reportes, entregables o el resultado del mes. Con la actividad o la evidencia basta.</mat-hint>
      </mat-form-field>
    </fieldset>

    <!-- ============================ El avance del trimestre ============================ -->
    <fieldset class="bsc-captura-dialog__grupo">
      <legend><span>Avance de Q{{ q }}</span></legend>
      <p class="bsc-captura-dialog__nota">
        Uno por trimestre: se corrige mientras Q{{ q }} no se envíe a revisión. Lo que no cambies se queda como está.
      </p>

      <div class="bsc-captura-dialog__numeros">
        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
          <mat-label>Avance real (%)</mat-label>
          <input matInput [id]="idReal" inputmode="decimal" autocomplete="off" [(ngModel)]="real" (ngModelChange)="cambio()"
                 [disabled]="!aplica || enviando || bloqueado || terminado || recargar"
                 [placeholder]="aplica ? 'p. ej. 90' : 'NA'" />
          <span matTextSuffix>%</span>
          <mat-hint [class.is-aviso]="avisoReal">{{ ayudaReal }}</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
          <mat-label>Programado (%)</mat-label>
          <input matInput aria-label="Programado (%)" id="bsc-captura-programado" inputmode="decimal" autocomplete="off" [(ngModel)]="programado"
                 (ngModelChange)="cambio()" [disabled]="!aplica || enviando || bloqueado || terminado || recargar"
                 [placeholder]="aplica ? '100' : 'NA'" />
          <span matTextSuffix>%</span>
          <mat-hint [class.is-aviso]="avisoProgramado">{{ ayudaProgramado }}</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic" *ngIf="conUnidades">
          <mat-label>Valor en unidades</mat-label>
          <input matInput aria-label="Valor en unidades" id="bsc-captura-unidades" inputmode="decimal" autocomplete="off" [(ngModel)]="unidades"
                 (ngModelChange)="cambio()" [disabled]="enviando || bloqueado || terminado || recargar"
                 placeholder="p. ej. 2" />
          <mat-hint>Informativo («2 de 6»): el cálculo usa el avance real.</mat-hint>
        </mat-form-field>
      </div>

      <p class="bsc-captura-dialog__previa" *ngIf="previa" aria-live="polite">{{ previa }}</p>

      <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
        <mat-label>Recursos</mat-label>
        <textarea matInput aria-label="Recursos" id="bsc-captura-recursos" rows="2" [(ngModel)]="recursos" (ngModelChange)="cambio()"
                  [disabled]="enviando || bloqueado || terminado || recargar"></textarea>
        <mat-hint>Quiénes y con qué (p. ej. líder, desarrolladores, ODP).</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
        <mat-label>Comentario del avance</mat-label>
        <textarea matInput aria-label="Comentario del avance" id="bsc-captura-comentario" rows="2" [maxlength]="largoComentario" [(ngModel)]="comentario"
                  (ngModelChange)="cambio()" [disabled]="enviando || bloqueado || terminado || recargar"></textarea>
        <mat-hint align="end">{{ comentario.length }}/{{ largoComentario }}</mat-hint>
      </mat-form-field>
    </fieldset>
  </div>

  <!-- Fuera del contenido que se desplaza, justo arriba de los botones: lo que se
       guardó con avisos y el error siempre quedan a la vista. -->
  <div class="bsc-captura-dialog__estado">
    <!-- Los avisos del servidor de lo que se guardó. -->
    <output class="bsc-captura-dialog__aviso" *ngIf="avisos.length > 0">
      <strong>Se guardó, con {{ avisos.length === 1 ? "un aviso" : avisos.length + " avisos" }}:</strong>
      <ul>
        <li *ngFor="let a of avisos; trackBy: trackAviso" [attr.title]="a.codigo || null">{{ a.texto }}</li>
      </ul>
    </output>

    <!-- El error o lo que falta. La región existe siempre (vacía no se ve): así el
         lector de pantalla anuncia el texto cuando llega. -->
    <p class="bsc-captura-dialog__mensaje" role="alert">{{ mensaje }}</p>
  </div>

  <footer mat-dialog-actions class="app-dialog__footer">
    <ng-container *ngIf="terminado; else editando">
      <button type="button" class="app-form-btn app-form-btn--secondary bsc-captura-dialog__listo"
              (click)="listo(false)">
        Listo
      </button>
      <button type="button" class="app-form-btn app-form-btn--primary" *ngIf="datos.haySiguiente && !recargar"
              (click)="listo(true)">
        Seguir con el siguiente
      </button>
    </ng-container>

    <ng-template #editando>
      <button type="button" class="app-form-btn app-form-btn--secondary" *ngIf="!recargar" [disabled]="enviando"
              (click)="cancelar()">
        Cancelar
      </button>
      <button type="button" class="app-form-btn app-form-btn--primary bsc-captura-dialog__recargar" *ngIf="recargar"
              (click)="recargarPantalla()">
        Recargar
      </button>
      <ng-container *ngIf="!recargar && !bloqueado">
        <button type="button" class="app-form-btn app-form-btn--secondary" *ngIf="datos.haySiguiente"
                [disabled]="enviando" [attr.aria-busy]="enviando" (click)="guardar(true)">
          Guardar y seguir
        </button>
        <button type="button" class="app-form-btn app-form-btn--primary" [disabled]="enviando"
                [attr.aria-busy]="enviando" (click)="guardar(false)">
          {{ enviando ? "Guardando…" : "Guardar" }}
        </button>
      </ng-container>
    </ng-template>
  </footer>
</section>
